/**
 * Peso da máquina no gargalo, como barra.
 *
 * "influência 33%" em texto miúdo obriga a comparar números de linhas diferentes para descobrir
 * se o motor mexeu onde importava. A barra responde isso de relance — e é o que justifica o
 * ajuste proposto ao lado.
 */
export function InfluenceBar({ pct }: { pct: number }) {
  if (!Number.isFinite(pct) || pct <= 0) return null;
  const clamped = Math.min(100, Math.max(0, pct));
  return (
    <div className="mt-1 flex items-center gap-2">
      <div
        className="h-1.5 w-24 overflow-hidden rounded-full bg-bg-sunken"
        role="img"
        aria-label={`Influência no gargalo: ${clamped.toFixed(0)}%`}
      >
        <div
          className="h-full w-[var(--infl-w)] rounded-full bg-brand-500"
          style={{ "--infl-w": `${clamped}%` } as React.CSSProperties}
        />
      </div>
      <span className="font-mono text-[10px] tabular-nums text-muted-foreground">
        {clamped.toFixed(0)}% de influência
      </span>
    </div>
  );
}
